import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Langs from "../../../app/lang/langs";
import { vlearnSurface, vlearnType } from "../vlearnUi";

/**
 * V-Learning — a lesson whose content is written text.
 *
 * `content_text` is rendered as text, with `white-space: pre-wrap` doing the work of the
 * author's own paragraph breaks. It is never passed to `dangerouslySetInnerHTML`.
 *
 * The reason is not stylistic. The field is typed by a course author and stored verbatim, so
 * rendering it as HTML would make any `<script>` an author pasted — knowingly or from a copied
 * Word document — execute in the session of every learner on the course. That is stored XSS
 * with a captive audience, and no amount of sanitising a string on the way out is as reliable
 * as never interpreting it in the first place.
 *
 * The measure is capped at 72 characters because a lesson is read, not scanned: full-width
 * prose on a wide monitor loses the reader's place at every line break.
 */
export default function TextLesson({ lesson }) {

    const text = lesson && lesson.content_text ? String(lesson.content_text) : ''

    if (!text.trim()) {
        return (
            <Box sx={{ ...vlearnSurface.panel }}>
                <Typography sx={{ ...vlearnType.body }}>
                    <Langs str="VLEARN_TEXT_EMPTY" />
                </Typography>
            </Box>
        )
    }

    return (
        <Box sx={{ ...vlearnSurface.panel, padding: { xs: '20px', md: '28px 32px' } }}>
            <Typography
                component="div"
                sx={{
                    whiteSpace: 'pre-wrap',
                    maxWidth: '72ch',
                    fontSize: '0.95rem',
                    lineHeight: 1.7,
                    color: 'var(--text-primary, #111318)'
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}
